<template>
  <div class="issue-page">
    <div class="content">
      <div class="left-box">
        <img :src="detail.imgUrl" class="banner" />
        <div class="time-box">
          <span class="num">{{ year }}</span>
          <span class="text">年</span>
          <span class="num">{{ month }}</span>
          <span class="text">月</span>
          <span class="num">{{ day }}</span>
          <span class="text">日</span>
          <span class="text2">{{ dayText }}</span>
          <span class="text2">{{ time }}</span>
        </div>
        <div class="swiper-container info-box" id="userList">
          <div class="swiper-wrapper" v-if="userList && userList.length">
            <div class="swiper-slide row-text" v-for="(bean, i) in userList" :key="bean.id" :id="'a' + i">
              <span>恭喜</span>
              <span class="red">{{ bean.name }}</span>
              <span>到单啦！</span>
            </div>
          </div>
          <div class="null" v-if="userList.length == 0 && !listLoading">
            <img class="null-img" src="@static/images/null3.png" />
            <span class="null-text">暂无内容</span>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="swiper-container list" id="list">
          <div class="swiper-wrapper" v-if="list && list.length">
            <div class="swiper-slide list-item" v-for="(bean, i) in list" :key="bean.id" :id="'b' + i">
              <div class="text-box full">
                <span class="text1">被保险人：</span>
                <span class="text2">{{ bean.insuranceName }}</span>
              </div>
              <div class="text-box full">
                <span class="text1">保单号：</span>
                <span class="text2">{{ bean.policyNo }}</span>
              </div>
              <div class="text-box full">
                <span class="text1">投保产品：</span>
                <span class="text2">{{ bean.productName }}</span>
              </div>
              <div class="text-box">
                <span class="text1">保费：</span>
                <span class="text2">{{ bean.fee || '0.00' }}元</span>
              </div>
              <div class="text-box">
                <span class="text1">保障额度：</span>
                <span class="text2">{{ bean.totalInsured || '0.00' }}元</span>
              </div>
              <div class="text-box">
                <span class="text1">交费期限：</span>
                <span class="text2">{{ bean.payPermDesc }}</span>
              </div>
              <div class="text-box">
                <span class="text1">保障期限：</span>
                <span class="text2">{{ bean.guarateeDesc }}</span>
              </div>
            </div>
          </div>
          <div class="null" v-if="list.length == 0 && !listLoading">
            <img class="null-img" src="@static/images/null3.png" />
            <span class="null-text">暂无内容</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'static/js/swiper-4.3.3.min';
import 'static/css/swiper-4.3.3.min.css';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      init: true, // 是否第一次加载
      listLoading: true,
      timer: null,
      curDomIndex: 2,
      year: '2024',
      month: '',
      day: '',
      dayText: '',
      time: '',
      detail: {},
      mySwiper1: null,
      mySwiper2: null,
      list: [],
      userList: []
    };
  },
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    this.$weixin.hideMenu();
    this.getData();
    this.timer = window.setInterval(this.getData, 10 * 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  methods: {
    getData() {
      this.$http({
        type: 'PUT',
        url: '/api/queryPolicyStatistics',
        hideAlert: true,
        data: {
          type: this.init ? 2 : 1
        }
      })
        .then(res => {
          localStorage.token = res.data.token;
          const data = res.data.data;
          if (data.date) {
            this.year = data.date.substr(0, 4);
            this.month = data.date.substr(5, 2) * 1;
            this.day = data.date.substr(8, 2) * 1;
            this.time = data.time.substr(0, 5);
            const dayMpa = {
              1: '星期日',
              2: '星期一',
              3: '星期二',
              4: '星期三',
              5: '星期四',
              6: '星期五',
              7: '星期六'
            };
            this.dayText = dayMpa[data.dayOfWeek];
          }
          // 经纪人数据处理
          data.salesmanNames = data.salesmanNames.map((name, i) => ({ name, id: 'i' + i + Date.now() }));
          let userList = [];
          if (data.salesmanNames && data.salesmanNames.length) {
            if (this.init || data.type == 2) {
              userList = data.salesmanNames;
            } else {
              userList = this.userList.concat(data.salesmanNames);
            }
            this.userList = userList.splice(-30);
            const isInitSwiper = document.getElementById('userList').className.includes('swiper-container-vertical');
            if (!isInitSwiper && this.userList.length > 4) {
              window.setTimeout(() => {
                this.mySwiper1 = new Swiper('#userList', {
                  slidesPerView: 4,
                  delay: 2000, // 自动播放间隔
                  speed: 1000, // 动画时间
                  direction: 'vertical',
                  autoplay: {
                    disableOnInteraction: false //用户操作swiper之后，是否禁止autoplay
                  },
                  loop: true,
                  observer: true, //修改swiper自己或子元素时，自动初始化swiper
                  observeParents: true //修改swiper的父元素时，自动初始化swiper
                });
              }, 50);
            } else if (this.userList.length <= 4) {
              this.mySwiper1?.destroy();
            }
          } else if (data.type == 2) {
            this.userList = [];
            this.mySwiper1?.destroy();
          }
          // 保单数据处理
          let list = data.policyList;
          if (list && list.length) {
            list.map((bean, i) => {
              bean.id = 'i' + i + Date.now();
            });
            if (this.init || data.type == 2) {
              list = data.policyList;
            } else {
              list = this.list.concat(data.policyList);
            }
            this.list = list.splice(-30);
            const isInitSwiper = document.getElementById('list').className.includes('swiper-container-vertical');
            if (!isInitSwiper && this.list.length > 1) {
              window.setTimeout(() => {
                this.mySwiper2 = new Swiper('#list', {
                  slidesPerView: 2,
                  delay: 2000, // 自动播放间隔
                  speed: 1000, // 动画时间
                  direction: 'vertical',
                  autoplay: {
                    disableOnInteraction: false //用户操作swiper之后，是否禁止autoplay
                  },
                  loop: true,
                  observer: true, //修改swiper自己或子元素时，自动初始化swiper
                  observeParents: true //修改swiper的父元素时，自动初始化swiper
                });
              }, 50);
            } else if (this.list.length == 1) {
              this.mySwiper2?.destroy();
            }
          } else if (data.type == 2) {
            this.list = [];
            this.mySwiper2?.destroy();
          }
          this.detail = data || {};
          this.init = false;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import './issue';
</style>
